export default "__VITE_ASSET__Di4hlM8C__"